import React, { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, MenuItem, Select, SelectChangeEvent, CardMedia, IconButton, Input } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AddGreekBox = () => {
  const navigate = useNavigate();

  // State for multiselects
  const [boxArt, setBoxArt] = React.useState<string[]>(["Select Art Box"]);
  const [flavors, setFlavors] = React.useState<string[]>(["Select Flavours"]);
  const [toppings, setToppings] = React.useState<string[]>(["Select Toppings"]);

  // State for inputs
  const [flavorMin, setFlavorMin] = useState<number>(0);
  const [flavorMax, setFlavorMax] = useState<number>(0);

  const [toppingMin, setToppingMin] = useState<number>(0);
  const [toppingMax, setToppingMax] = useState<number>(0);

  // Handlers
  const handleBoxArtChange = (event: SelectChangeEvent<string[]>) => {
    setBoxArt(event.target.value as string[]);
  };

  const handleFlavorsChange = (event: SelectChangeEvent<string[]>) => {
    setFlavors(event.target.value as string[]);
  };

  const handleToppingsChange = (event: SelectChangeEvent<string[]>) => {
    setToppings(event.target.value as string[]);
  };

  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  return (
    <>
      <div className="main_title">
        <h1>Add Greek Box</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {" "} - <button onClick={() => navigate("/manage-greek-box")}>Manage Greek Box</button>
          {" "} - Add Greek Box
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group">
              <label htmlFor="icon-button-file">Upload Image</label>
              <div className="image_grid">
                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia
                          component="img"
                          image={image}
                          alt="Uploaded profile photo"
                        />
                      </figure>
                      <IconButton
                        aria-label="Remove uploaded image"
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  </div>
                ) : (
                  <label
                    className="upload_image no_radius"
                    htmlFor="icon-button-file"
                  >
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{ accept: "image/png,image/jpeg" }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = (event.target as HTMLInputElement).files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/placeholder.png"
                          alt="placeholder"
                        />
                        <span className="upload_img_icon">
                          <img
                            src="/static/images/edit2_icon.svg"
                            alt="Upload"
                          />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}

                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia
                          component="img"
                          image={image}
                          alt="Uploaded profile photo"
                        />
                      </figure>
                      <IconButton
                        aria-label="Remove uploaded image"
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  </div>
                ) : (
                  <label
                    className="upload_image no_radius"
                    htmlFor="icon-button-file"
                  >
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{ accept: "image/png,image/jpeg" }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = (event.target as HTMLInputElement).files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/placeholder.png"
                          alt="placeholder"
                        />
                        <span className="upload_img_icon">
                          <img
                            src="/static/images/edit2_icon.svg"
                            alt="Upload"
                          />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
            </div>


            <div className="control_group w_66">
              <label htmlFor="name">Name</label>
              <TextField id="name" placeholder="Enter Name" hiddenLabel fullWidth />
            </div>

            <div className="control_group w_33">
              <label htmlFor="price">Price</label>
              <TextField id="price" placeholder="Enter Price" hiddenLabel fullWidth />
            </div>

            <div className="control_group w_100">
              <label htmlFor="description">Description</label>
              <TextField
                id="description"
                placeholder="Enter Description"
                hiddenLabel
                fullWidth
                multiline
                rows={3}
              />
            </div>

            <div className="control_group w_100">
              <label htmlFor="boxArt">Box Art</label>
              <Select
                id="boxArt"
                fullWidth
                multiple
                value={boxArt}
                onChange={handleBoxArtChange}
                renderValue={(selected) => selected.join(", ")}
              >
                <MenuItem value="default" disabled>Select Art Box</MenuItem>
                <MenuItem value="Art 1">Art 1</MenuItem>
                <MenuItem value="Art 2">Art 2</MenuItem>
                <MenuItem value="Art 3">Art 3</MenuItem>
              </Select>
            </div>

            <div className="control_group w_66">
              <label htmlFor="flavors">Flavors</label>
              <Select
                id="flavors"
                fullWidth
                multiple
                value={flavors}
                onChange={handleFlavorsChange}
                renderValue={(selected) => selected.join(", ")}
              >
                <MenuItem value="default" disabled>Select Flavors</MenuItem>
                <MenuItem value="Flavor 1">Flavor 1</MenuItem>
                <MenuItem value="Flavor 2">Flavor 2</MenuItem>
                <MenuItem value="Flavor 3">Flavor 3</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <div className="gap_p">
                <div className="control_group w_50">
                  <label htmlFor="flavorMin">Flavors Min Count</label>
                  <TextField
                    id="flavorMin"
                    type="number"
                    placeholder="Min"
                    hiddenLabel
                    fullWidth
                    inputProps={{ min: 0 }}
                    value={flavorMin}
                    onChange={(e) => {
                      const value = Number(e.target.value);
                      setFlavorMin(value >= 0 ? value : 0);
                    }}
                  />
                </div>

                <div className="control_group w_50">
                  <label htmlFor="flavorMax">Flavors Max Count</label>
                  <TextField
                    id="flavorMax"
                    type="number"
                    placeholder="Max"
                    hiddenLabel
                    fullWidth
                    inputProps={{ min: 0 }}
                    value={flavorMax}
                    onChange={(e) => {
                      const value = Number(e.target.value);
                      if (value >= flavorMin) setFlavorMax(value);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="control_group w_66">
              <label htmlFor="toppings">Toppings</label>
              <Select
                id="toppings"
                fullWidth
                multiple
                value={toppings}
                onChange={handleToppingsChange}
                renderValue={(selected) => selected.join(", ")}
              >
                <MenuItem value="default" disabled>Select Toppings</MenuItem>
                <MenuItem value="Topping 1">Topping 1</MenuItem>
                <MenuItem value="Topping 2">Topping 2</MenuItem>
                <MenuItem value="Topping 3">Topping 3</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <div className="gap_p">
                <div className="control_group w_50">
                  <label htmlFor="toppingMin">Toppings Min Count</label>
                  <TextField
                    id="toppingMin"
                    type="number"
                    placeholder="Min"
                    hiddenLabel
                    fullWidth
                    inputProps={{ min: 0 }}
                    value={toppingMin}
                    onChange={(e) => {
                      const value = Number(e.target.value);
                      setToppingMin(value >= 0 ? value : 0);
                    }}
                  />
                </div>

                <div className="control_group w_50">
                  <label htmlFor="toppingMax">Toppings Max Count</label>
                  <TextField
                    id="toppingMax"
                    type="number"
                    placeholder="Max"
                    hiddenLabel
                    fullWidth
                    inputProps={{ min: 0 }}
                    value={toppingMax}
                    onChange={(e) => {
                      const value = Number(e.target.value);
                      if (value >= toppingMin) setToppingMax(value);
                    }}
                  />
                </div>
              </div>
            </div>

          </div>

          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddGreekBox;
